export default "__VITE_ASSET__myR9O_e$__"